import BugsnagPerformance from "@bugsnag/browser-performance";
import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";

Bugsnag.start({
  apiKey: `${process.env.API_KEY_BUGSNAG}`,
  plugins: [new BugsnagPluginVue()],
});
BugsnagPerformance.start({ apiKey: `${process.env.API_KEY_BUGSNAG}` });
export default Bugsnag;
